import React, { useState, KeyboardEvent } from 'react';
import { Title, Text, Icon } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface AccordionTextProps {
    title: string;
    text?: string;
    show?: boolean;
}

const AccordionText: React.FC<AccordionTextProps> = ({
    title,
    text,
    show = false,
}) => {
    const [isOpen, setOpen] = useState(show);

    const handleToggle = () => setOpen(!isOpen);

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            handleToggle();
        }
    };

    return (
        <div
            className={cls(
                'bg-background-secondary rounded-medium overflow-hidden hover:bg-background-brand-primary focus-visible:outline outline-stroke-focus text-text-primary',
                !text &&
                    '!bg-background-disabled !text-text-disabled focus-visible:outline-0',
            )}
            onKeyDown={text ? onKeyDown : undefined}
            tabIndex={0}>
            <button
                onClick={text ? handleToggle : undefined}
                className={cls(
                    'flex items-center justify-between gap-[24px] text-start p-lg w-full focus-visible:outline-0 transition-all ease-in-out duration-500 ',
                )}>
                <Title component="h4" className="text-b200 flex-1">
                    {title}
                </Title>

                <Icon
                    icon={
                        isOpen
                            ? 'arrow-cricle--type-up'
                            : 'arrow-cricle--type-down'
                    }
                    className="text-[24px]"
                />
            </button>
            <div
                className={cls(
                    'grid grid-rows-[0fr] opacity-0 transition-all ease-in-out duration-500 !cursor-auto',
                    isOpen && 'grid-rows-[1fr] opacity-100',
                )}>
                {text && (
                    <div className="overflow-hidden flex flex-col px-lg">
                        <Text
                            isHtml
                            component="div"
                            className="text-b400 pb-lg text-text-secondary unordered-list-items blockquote-list-icon [&>*]:text-text-primary [&>*]:hd:pr-extra [&_blockquote>ul]:mb-24 [&_blockquote>ul>li]:mb-16 [&_blockquote>ul>li:last-child]:mb-0 [&_p>strong]:font-semibold [&>p]:pb-24 [&>:last-child]:!pb-0">
                            {text}
                        </Text>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccordionText;
